import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Paginable } from '../../utils/pagination.utils';
import { RealEstateLocationMunicipalityPaginableParams, RealEstateLocationNeighborhoodPaginableParams, RealEstateLocationSearchParams, RealEstateLocationStatePaginableParams, RealEstateLocationSuggestion, RealEstateLocationsService } from './real-estate-locations.service';

@Injectable()
export class RealEstateLocationsServiceApi implements RealEstateLocationsService {
  constructor(
    private http: HttpClient,
  ) {}

  async getAllMunicipalities(params: RealEstateLocationMunicipalityPaginableParams): Promise<Paginable<string>> {
    const { limit, page } = params;
    const queryParams = new URLSearchParams({
      limit: `${limit}`,
      page: `${page}`,
      state: params.state,
    });
    const { data } = await firstValueFrom(this.http.get<{ data: Paginable<string>; }>(`${environment.apiUrl2}/real-estate-locations/municipalities?${queryParams.toString()}`));
    return data;
  }

  async getAllNeighborhoods(params: RealEstateLocationNeighborhoodPaginableParams): Promise<Paginable<string>> {
    const { limit, page } = params;
    const queryParams = new URLSearchParams({
      limit: `${limit}`,
      page: `${page}`,
      municipality: params.municipality,
      state: params.state,
    });
    const { data } = await firstValueFrom(this.http.get<{ data: Paginable<string>; }>(`${environment.apiUrl2}/real-estate-locations/neighborhoods?${queryParams.toString()}`));
    return data;
  }

  async getAllStates(params: RealEstateLocationStatePaginableParams): Promise<Paginable<string>> {
    const { limit, page } = params;
    const queryParams = new URLSearchParams({
      limit: `${limit}`,
      page: `${page}`,
    });
    const { data } = await firstValueFrom(this.http.get<{ data: Paginable<string>; }>(`${environment.apiUrl2}/real-estate-locations/states?${queryParams.toString()}`));
    return data;
  }

  async search(params: RealEstateLocationSearchParams): Promise<RealEstateLocationSuggestion[]> {
    const queryParams = new URLSearchParams({
      limit: `${params.limit}`,
      term: params.term,
    });
    const { data } = await firstValueFrom(this.http.get<{ data: RealEstateLocationSuggestion[]; }>(`${environment.apiUrl2}/real-estate-locations?${queryParams.toString()}`));
    return data;
  }
}
